import React from 'react'
import ShrekPic from '../components/photos/shrek.webp'
import { Link } from 'react-router-dom'


export default function Purchase() {
    return (
        <div className='fullpage'>
            <div className='purchase-div'>
                <iframe src="https://docs.google.com/presentation/d/e/2PACX-1vT9VdLBBoacKdnO-eWQXU5OR20LHAGvCj5aFeyjw42-blYDIIKhQpLgJNMPjxRAi6c8pyLzKRLwAI7U/embed?start=false&loop=true&delayms=5000" frameborder="0" width="1440" height="839" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true"></iframe>
            </div>
        </div>
    )
}